__webpack_require__.p = "/figma-colors-sync-fixes/onboarding/";